import SonicBoomArticle from "components/kbl/SonicBoomArticle";
import SonicBoomGuide from "components/kbl/SonicBoomGuide";
import SonicBoomLocation from "components/kbl/SonicBoomLocation";
import SonicBoomSchedule from "components/kbl/SonicBoomSchedule";
import React from "react";
import { Route, Switch } from "react-router-dom";

const SonicBoomPage = () => {
  return (
    <Switch>
      <Route path="/kbl/sonicboom/notice" component={SonicBoomArticle} />
      <Route path="/kbl/sonicboom/notice/:seq" component={SonicBoomArticle} />
      <Route path="/kbl/sonicboom/guide" component={SonicBoomGuide} />
      <Route path="/kbl/sonicboom/location" component={SonicBoomLocation} />
      <Route path="/kbl/sonicboom/schedule" component={SonicBoomSchedule} />
    </Switch>
  );
};

export default SonicBoomPage;
